





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Scanner extends Vue {
  @Prop({ default: 'verify'}) public action!: string;

  public address = '';
  public ppv = '';
  public pk = '';
  public ppt = '';

  public rules = {
    required: (value: string) => !!value || 'Required.',
    addresslength: (value: string) => value.length === 39 || 'Invalid Value.',
    publickeylength: (value: string) => value.length === 64 || 'Invalid Value.',
    privatekeylength: (value: string) => (value.length === 64 || value.length === 66) || 'Invalid Value.',
    addresspattern: (value: string) => {
      value = value.toString().toUpperCase().replace(/-/g, '');
      // TODO: implement address check
      // https://github.com/QuantumMechanics/NEM-sdk/blob/master/src/model/address.js#L127
      return true || 'Invalid Value.';
    },
    hexpattern: (value: string) => {
      const pattern = /^(0x|0X)?[a-fA-F0-9]+$/;
      return pattern.test(value) || 'Invalid Value.';
    }
  };

  public verify() {
    if ((this.$refs.verifyInput as Vue & { validate: () => boolean }).validate()) {
      this.$emit('decode', this.ppv);
    }
  }

}
